import { Permit } from "@services/dtos/permit.dto";
import { useThemeStore } from "@stores/theme.store";
import { useDetailState } from "@utils/detail_state";
import { linkPage } from "@utils/router";
import moment from "moment";
import { useEffect } from "react";

export const PermitDataDetailPage = () => {
  const state = useDetailState<Permit>(linkPage.PERMIT_DATA);
  const { setFooter, setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setFooter(false);
    setHeader({
      type: "small",
      title: "Detail Izin",
      buttonBack: true,
      avatar: true,
    });
    setAppBar({ title: "Detail Izin", leading: "back" });
  }, [setFooter, setHeader, setAppBar]);

  if (!state) return null;

  return (
    <div className="card card-style">
      <div className="content d-flex flex-column mb-0">
        <div className="color-highlight">Status Izin</div>
        <div className="color-theme mb-3">
          {state.acc === "Y"
            ? "Diizinkan"
            : state.acc === "N"
            ? "Tidak Diizinkan"
            : state.acc === "BELUM"
            ? "Belum Disetujui"
            : "-"}
        </div>
        <div className="color-highlight">Tanggal Izin</div>
        <div className="color-theme mb-3">
          {moment(state.datePermit ?? Date.now()).format("dddd, DD MMMM YYYY")}
        </div>
        {/* <div className="color-highlight">Tanggal Izin</div>
        <div className="color-theme mb-3">{moment(state.dateBack ?? Date.now()).format('dddd, DD MMMM YYYY')}</div> */}
        <div className="color-highlight">Jenis Izin</div>
        <div className="color-theme mb-3">{state.mode ?? "-"}</div>
        {/* <div className="color-highlight">Waktu Izin</div>
        <div className="color-theme mb-3">{state.time ?? "-"}</div> */}
        <div className="color-highlight">Catatan Admin</div>
        <div className="color-theme mb-3">
          {state.adminNotes === "" ? "-" : state.adminNotes}
        </div>
        <div className="color-highlight">Nama Penjemput</div>
        <div className="color-theme mb-3">{state.pickup ?? "-"}</div>
        <div className="color-highlight">Status Penjemput</div>
        <div className="color-theme mb-3">{state.pickupStatus ?? "-"}</div>
        <div className="color-highlight">Catatan</div>
        <div className="color-theme mb-3">{state.notes ?? "-"}</div>
      </div>
    </div>
  );
};
